"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6245],{

/***/ 94825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44731);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79697);
/* harmony import */ var utils_api_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68056);





const DEFAULT_AVATAR = "/img/defaultPhoto.svg";
const Avatar = (param)=>{
    let { className , src , ...rest } = param;
    const { me , loggedIn  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useLoginData */ .Q)();
    const [avatarSrc, setAvatarSrc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(DEFAULT_AVATAR);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (me && loggedIn) {
            var _me_avatar, _me_avatar_thumbImage;
            const thumbImageUrl = me === null || me === void 0 ? void 0 : (_me_avatar = me.avatar) === null || _me_avatar === void 0 ? void 0 : (_me_avatar_thumbImage = _me_avatar.thumbImage) === null || _me_avatar_thumbImage === void 0 ? void 0 : _me_avatar_thumbImage.url;
            setAvatarSrc((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(thumbImageUrl) ? DEFAULT_AVATAR : thumbImageUrl);
        }
    }, [
        me,
        loggedIn
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: className,
        src: (0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src) ? avatarSrc : src,
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 55856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ MaxWidthWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var config_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26059);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: ",
        ";\n  margin-left: auto;\n  margin-right: auto;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}





const StyledContentWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $xs , $lg , $xl , $xxl , $widthLimit , $isHomePage  } = param;
    return "\n    width: 100%;\n    max-width: ".concat($widthLimit ? $isHomePage ? config_theme__WEBPACK_IMPORTED_MODULE_4__/* .indexPageMaxContentWidth */ .LN : config_theme__WEBPACK_IMPORTED_MODULE_4__/* .maxContentWidth */ .xN : "none", ";\n    margin-left: auto;\n    margin-right: auto;\n\n    padding-left: ").concat(theme.spacing($xs ? 4 : 0), ";\n    padding-right: ").concat(theme.spacing($xs ? 4 : 0), ";\n\n    ").concat($isHomePage ? "\n        padding-left: ".concat(theme.spacing($xs ? 4 : 0), ";\n        padding-right: ").concat(theme.spacing($xs ? 4 : 0), ";\n\n        ").concat(theme.breakpoints.up("md"), " {\n          padding-left: ").concat(theme.spacing(8), ";\n          padding-right: ").concat(theme.spacing(8), ";\n        }\n\n        ").concat(theme.breakpoints.up("xl"), " {\n          padding-left: ").concat(theme.spacing($xl ? 12 : 0), ";\n          padding-right: ").concat(theme.spacing($xl ? 12 : 0), ";\n        }\n      ") : "\n        ".concat(theme.breakpoints.up("lg"), " {\n          padding-left: ").concat(theme.spacing($lg ? 9 : 0), ";\n          padding-right: ").concat(theme.spacing($lg ? 9 : 0), ";\n        }\n\n        ").concat(theme.breakpoints.up("xl"), " {\n          padding-left: ").concat(theme.spacing($xl ? 12 : 0), ";\n          padding-right: ").concat(theme.spacing($xl ? 12 : 0), ";\n        }\n\n        ").concat(theme.breakpoints.up("xxl"), " {\n          padding-left: ").concat(theme.spacing($xxl ? 16 : 0), ";\n          padding-right: ").concat(theme.spacing($xxl ? 16 : 0), ";\n        }\n      "), "\n  ");
});
const ContentWrapper = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const isHomePage = router.pathname === "/";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContentWrapper, {
        $isHomePage: isHomePage,
        ...props
    });
};
ContentWrapper.defaultProps = {
    $xs: true,
    $lg: true,
    $xl: true,
    $xxl: true,
    $widthLimit: true,
    $isHomePage: false
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentWrapper);
const MaxWidthWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject1(), config_theme__WEBPACK_IMPORTED_MODULE_4__/* .maxContentWidth */ .xN);


/***/ }),

/***/ 75883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./config/theme.js + 1 modules
var theme = __webpack_require__(26059);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./components/common/PopupSearchPanel/hooks.js
var hooks = __webpack_require__(14581);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/lodash-es/some.js + 1 modules
var some = __webpack_require__(34081);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./utils/api/hooks/useLoginData.js
var useLoginData = __webpack_require__(68056);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
// EXTERNAL MODULE: ./components/common/Avatar/index.js
var Avatar = __webpack_require__(94825);
;// CONCATENATED MODULE: ./components/common/MenuListC/index.js











const DynamicPopperMenu = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9477), __webpack_require__.e(8402), __webpack_require__.e(376), __webpack_require__.e(9255)]).then(__webpack_require__.bind(__webpack_require__, 99255)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(99255)
            ]
    },
    ssr: false
});
const MenuListC = (param)=>{
    let { isLarge , greeting  } = param;
    const { loggedIn , me  } = (0,useLoginData/* useLoginData */.Q)();
    const [isProfileComplete, setIsProfileComplete] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (me) {
            var _me_contactAddress, _me_contactAddress1, _me_contactAddress2;
            const isProfileFilledUp = !(0,some/* default */.Z)([
                me.fullname,
                me.email,
                me.birthday,
                (_me_contactAddress = me.contactAddress) === null || _me_contactAddress === void 0 ? void 0 : _me_contactAddress.county,
                (_me_contactAddress1 = me.contactAddress) === null || _me_contactAddress1 === void 0 ? void 0 : _me_contactAddress1.district,
                (_me_contactAddress2 = me.contactAddress) === null || _me_contactAddress2 === void 0 ? void 0 : _me_contactAddress2.details
            ], isEmpty/* default */.Z);
            const isGenderFilledUp = [
                "女性",
                "男性",
                "不願透露"
            ].includes(me.gender);
            const isComplete = isProfileFilledUp && isGenderFilledUp;
            setIsProfileComplete(isComplete);
        }
    }, [
        me
    ]);
    const theme = (0,useTheme/* default */.Z)();
    const isSmall = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const [open, setOpen] = (0,react.useState)(false);
    const anchorRef = (0,react.useRef)(null);
    const handleToggle = ()=>{
        if (!isSmall) return;
        if (!open) {
            GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                event: "living_action",
                living_event_name: "membermenu_imp"
            });
        }
        setOpen((prevOpen)=>!prevOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        display: "flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                ref: anchorRef,
                "aria-controls": open ? "menu-list-grow" : undefined,
                "aria-haspopup": "true",
                pl: loggedIn ? 1.5 : 3,
                py: loggedIn ? 2.5 : 4,
                onClick: handleToggle,
                onMouseEnter: ()=>{
                    if (!isSmall) {
                        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                            event: "living_action",
                            living_event_name: "membermenu_imp"
                        });
                        setOpen(true);
                    }
                },
                onMouseLeave: ()=>!isSmall ? setOpen(false) : "",
                children: [
                    loggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                sx: {
                                    width: 36,
                                    height: 36
                                },
                                style: {
                                    cursor: "pointer"
                                }
                            }),
                            !isProfileComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                position: "absolute",
                                top: 0,
                                right: 0,
                                border: "1px solid white",
                                borderRadius: "50%",
                                width: 8,
                                height: 8,
                                bgcolor: "red"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            display: "flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/img/user.svg",
                                width: "24",
                                height: "24",
                                style: {
                                    cursor: "pointer"
                                },
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicPopperMenu, {
                        isSmall: isSmall,
                        greeting: greeting,
                        open: open,
                        onClose: ()=>setOpen(false),
                        iconRef: anchorRef.current
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var common_MenuListC = (MenuListC);

// EXTERNAL MODULE: ./node_modules/lodash-es/random.js + 1 modules
var random = __webpack_require__(42179);
// EXTERNAL MODULE: ./utils/api/hooks/useCatalogsServiceMenus.js
var useCatalogsServiceMenus = __webpack_require__(7269);
// EXTERNAL MODULE: ./utils/hooks/fetchers.js
var fetchers = __webpack_require__(86700);
;// CONCATENATED MODULE: ./utils/api/hooks/useGreetings.js

const useGreetings = (props)=>{
    var _data_;
    const { data , ...rest } = (0,fetchers/* useCustomSWR */.LW)("/systemSettings/specificKey?key=greeting");
    return {
        data: data === null || data === void 0 ? void 0 : (_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.value,
        ...rest
    };
};

// EXTERNAL MODULE: ./store/selfConstruct/selfConstructSlice.js
var selfConstructSlice = __webpack_require__(67030);
;// CONCATENATED MODULE: ./components/common/Header/index.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: ",
        ";\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}

















const DynamicSearchPanel = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(9477), __webpack_require__.e(5616), __webpack_require__.e(6541), __webpack_require__.e(8402), __webpack_require__.e(8277), __webpack_require__.e(4333)]).then(__webpack_require__.bind(__webpack_require__, 8277)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8277)
            ]
    },
    ssr: false
});
const DynamicMenuModalHorizontal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9477), __webpack_require__.e(5616), __webpack_require__.e(9860), __webpack_require__.e(9067)]).then(__webpack_require__.bind(__webpack_require__, 49067)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(49067)
            ]
    },
    ssr: true
});
const DynamicNavButtonList = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(6271)]).then(__webpack_require__.bind(__webpack_require__, 36271)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(36271)
            ]
    },
    ssr: true
});
const DynamicSearchButton = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4655).then(__webpack_require__.bind(__webpack_require__, 94655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(94655)
            ]
    },
    ssr: false
});
const HeaderWrap = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject(), theme/* headerHeight */.J9, theme/* indexPageMaxContentWidth */.LN);
const StyleContentWrapper = (0,emotion_styled_browser_esm/* default */.Z)(ContentWrapper/* default */.Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    padding-left: ".concat(theme.spacing(4), ";\n    padding-right: ").concat(theme.spacing(4), ";\n\n    ").concat(theme.breakpoints.up("md"), " {\n      padding-left: ").concat(theme.spacing(4), ";\n      padding-right: ").concat(theme.spacing(4), ";\n    }\n    ").concat(theme.breakpoints.up("lg"), " {\n      padding-left: ").concat(theme.spacing(8), ";\n      padding-right: ").concat(theme.spacing(8), ";\n    }\n    ").concat(theme.breakpoints.up("xl"), " {\n      padding-left: ").concat(theme.spacing(12), ";\n      padding-right: ").concat(theme.spacing(12), ";\n    }\n  ");
});
const Logo = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject2());
const Header = ()=>{
    const router = (0,next_router.useRouter)();
    const onLogoClick = ()=>{
        router.push("/");
    };
    const onCatalogOrSubMenuClick = (item)=>{
        if (item.link) {
            if (item.linkTarget === "blank") {
                window.open(item.link, "_blank");
            } else {
                router.push(item.link);
            }
        }
        setMenuModalOpen(false);
    };
    const onServiceClassificationClick = (item)=>{
        const isServiceClassification = item.type === "serviceClassification";
        if (isServiceClassification) {
            var _item_serviceClassification;
            router.push("/vender?serviceItem=".concat(item === null || item === void 0 ? void 0 : (_item_serviceClassification = item.serviceClassification) === null || _item_serviceClassification === void 0 ? void 0 : _item_serviceClassification._id));
        } else {
            if (item.linkTarget === "blank") {
                window.open(item.link, "_blank");
            } else {
                router.push(item.link);
            }
        }
    };
    const webviewName = (0,es/* useSelector */.v9)(webviewSlice/* selectWebviewName */.TN);
    const selfConstruct = (0,es/* useSelector */.v9)(selfConstructSlice/* selectSelfConstruct */.k$);
    const theme = (0,useTheme/* default */.Z)();
    const isSmall = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const { searchPanelOpen , setSearchPanelOpen , onSearchPanelClose  } = (0,hooks/* useSearchPanel */.J)(webviewName);
    const onSearchIconClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setSearchPanelOpen(!searchPanelOpen);
    };
    const { data: ServiceMenus  } = (0,useCatalogsServiceMenus/* useCatalogsServiceMenus */.J)({
        target: "headerMenu"
    });
    // 主選單依序按照 sort 由大到小、createdAt 由新到舊排序
    if (Array.isArray(ServiceMenus)) {
        ServiceMenus.sort((a, b)=>{
            if (b.sort !== a.sort) {
                return b.sort - a.sort;
            }
            return new Date(b.createdAt) - new Date(a.createdAt);
        });
    }
    const { data: greetings  } = useGreetings();
    const greetingsArray = (greetings === null || greetings === void 0 ? void 0 : greetings.split("/")) || [];
    const greetingIndex = (0,random/* default */.Z)((greetingsArray === null || greetingsArray === void 0 ? void 0 : greetingsArray.length) - 1);
    const [menuModalOpen, setMenuModalOpen] = (0,react.useState)(false);
    const onMenuModalClose = ()=>setMenuModalOpen(false);
    if (webviewName === "lsApp") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSearchPanel, {
                open: searchPanelOpen,
                onClose: onSearchPanelClose
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        position: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleContentWrapper, {
                $xxl: false,
                $xs: true,
                $isHomePage: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            flexGrow: 1,
                            display: "flex",
                            alignItems: "center",
                            children: [
                                isSmall && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    pr: 3,
                                    py: 4,
                                    display: "flex",
                                    onClick: ()=>setMenuModalOpen(true),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        width: 24,
                                        height: 24,
                                        src: "/img/menu-icon.svg",
                                        style: {
                                            cursor: "pointer"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                    src: "/img/logo.svg",
                                    alt: "",
                                    width: 135,
                                    onClick: onLogoClick
                                }),
                                !isSmall && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicNavButtonList, {
                                    catalogs: ServiceMenus,
                                    onCatalogOrSubMenuClick: onCatalogOrSubMenuClick,
                                    onServiceClassificationClick: onServiceClassificationClick
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    mr: isSmall ? 1 : 3,
                                    display: "inline-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSearchButton, {
                                        onSearchIconClick: onSearchIconClick
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_MenuListC, {
                                    greeting: greetingsArray[greetingIndex]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSearchPanel, {
                open: searchPanelOpen,
                onClose: onSearchPanelClose
            }),
            isSmall && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMenuModalHorizontal, {
                catalogs: ServiceMenus,
                open: menuModalOpen,
                onClose: onMenuModalClose,
                onCatalogOrSubMenuClick: onCatalogOrSubMenuClick,
                onServiceClassificationClick: onServiceClassificationClick
            })
        ]
    });
};
/* harmony default export */ var common_Header = (Header);


/***/ }),

/***/ 82023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62097);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  // 手機瀏覽器設置100vh會被瀏覽器本身上下方的元件覆蓋\n  // 改用此方案\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-grow: 1;\n  ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}





const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject());
const ContentWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1());
const Grow = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject2(), (props)=>props.fixHeight ? "min-height: 100%" : "", (props)=>props.fixHeight ? "display: flex" : "", (props)=>props.fixHeight ? "flex-direction: column" : "");
const Layout = (param)=>{
    let { header , stickyHeader , footer , stickyFooter , fixContentHeight , children , contentWrapperRef , contentWrapperId  } = param;
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const isDesktop = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(theme.breakpoints.up("lg"));
    // 無法直接使用 contentWrapperRef，所以多宣告 scopedContentWrapperRef 在 Layout 裡使用
    const scopedContentWrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const refHandler = (el)=>{
        if (contentWrapperRef) {
            contentWrapperRef.current = el;
        }
        if (scopedContentWrapperRef) {
            scopedContentWrapperRef.current = el;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        children: [
            !!stickyHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: typeof stickyHeader === "function" ? stickyHeader() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: stickyHeader
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentWrapper, {
                id: contentWrapperId,
                ref: refHandler,
                children: [
                    !!header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: typeof header === "function" ? header() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: header
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Grow, {
                        fixHeight: fixContentHeight,
                        children: children
                    }),
                    !!footer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: typeof footer === "function" ? footer() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: footer
                        })
                    })
                ]
            }),
            !!stickyFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: typeof stickyFooter === "function" ? stickyFooter() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: stickyFooter
                })
            })
        ]
    });
};
Layout.defaultProps = {
    contentWrapperId: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 14581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useSearchPanel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useSearchPanel = (webviewName)=>{
    const [searchPanelOpen, setSearchPanelOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const onSearchPanelClose = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setSearchPanelOpen(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (webviewName === "lsApp") {
            window.__onNativeSearchClick = ()=>setSearchPanelOpen(!searchPanelOpen);
        }
        return ()=>{
            window.__onNativeSearchClick = null;
        };
    }, [
        webviewName,
        searchPanelOpen
    ]);
    return {
        searchPanelOpen,
        setSearchPanelOpen,
        onSearchPanelClose
    };
};


/***/ }),

/***/ 7269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useCatalogsServiceMenus; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72673);



const useCatalogsServiceMenus = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        limit: 999
    };
    const genUrl = ()=>utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .ZP.getToken() ? [
            "/catalogs/serviceMenus?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(props)),
            utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .ZP.getToken()
        ] : "/catalogs/serviceMenus?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(props));
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, utils_request__WEBPACK_IMPORTED_MODULE_2__/* .lsGetWithToken */ .n8);
};


/***/ }),

/***/ 27582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ GtmAgent; }
/* harmony export */ });
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73221);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42395);


/**
 * 當是 web view 時，會呼叫 GtmAgent.setDisable(true)
 */ const GtmAgent = function() {
    let cache = [];
    const flushCacheData = ()=>{
        for (const data of cache){
            directSendToGTM(data);
        }
        cache = [];
    };
    let isAuthEventSent = false;
    const sendAuthEvent = (userId)=>{
        isAuthEventSent = true;
        directSendToGTM({
            event: _constants__WEBPACK_IMPORTED_MODULE_1__/* .USER_ID */ .E1,
            category: "livingec",
            userId
        });
        if (isAuthEventSent && sidSettled) {
            flushCacheData();
        }
    };
    let sidSettled = false;
    let sid = "";
    const setSID = (newSID)=>{
        sid = newSID;
        sidSettled = true;
        if (isAuthEventSent && sidSettled) {
            flushCacheData();
        }
    };
    let disable = false;
    const setDisable = (bool)=>disable = bool;
    // 確保 dataLayer 存在並推送資料
    const pushToDataLayer = (data)=>{
        if (true) {
            window[config_constants__WEBPACK_IMPORTED_MODULE_0__/* .GTM_DEFAULT_DATA_LAYER */ .MH] = window[config_constants__WEBPACK_IMPORTED_MODULE_0__/* .GTM_DEFAULT_DATA_LAYER */ .MH] || [];
            window[config_constants__WEBPACK_IMPORTED_MODULE_0__/* .GTM_DEFAULT_DATA_LAYER */ .MH].push(data);
        }
    };
    // 因 SID 關閉而暫時不會用到
    const sendToGTMAfterSID = (data)=>{
        if (disable) {
            return;
        }
        if (isAuthEventSent && sidSettled) {
            pushToDataLayer(data);
        } else {
            cache.push(data);
        }
    };
    const directSendToGTM = (data)=>{
        if (disable) {
            return;
        }
        pushToDataLayer(data);
    };
    return {
        setDisable,
        sendAuthEvent,
        setSID,
        sendToGTMAfterSID,
        directSendToGTM
    };
}();


/***/ }),

/***/ 42395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CV": function() { return /* binding */ PURCHASE; },
/* harmony export */   "E1": function() { return /* binding */ USER_ID; },
/* harmony export */   "G2": function() { return /* binding */ ADD_TO_CART; },
/* harmony export */   "L_": function() { return /* binding */ VENDER_PAGEVIEW; },
/* harmony export */   "Qn": function() { return /* binding */ BANNER_IMPRESSION_UNIQUE; },
/* harmony export */   "Xi": function() { return /* binding */ PRODUCT_IMPRESSION_CLICK; },
/* harmony export */   "YT": function() { return /* binding */ ALBUM_DETAIL; },
/* harmony export */   "Zd": function() { return /* binding */ BANNER_CLICK; },
/* harmony export */   "a4": function() { return /* binding */ ARTICLE_PAGEVIEW; },
/* harmony export */   "hf": function() { return /* binding */ PRODUCT_IMPRESSION; },
/* harmony export */   "iK": function() { return /* binding */ CHECKOUT; },
/* harmony export */   "jQ": function() { return /* binding */ PRODUCT_INTRO; },
/* harmony export */   "lY": function() { return /* binding */ BANNER_IMPRESSION_REPEATED; },
/* harmony export */   "nM": function() { return /* binding */ PRODUCT_DETAIL; },
/* harmony export */   "q6": function() { return /* binding */ ALBUM_PAGEVIEW; },
/* harmony export */   "vL": function() { return /* binding */ ASSESSED_PRICE; }
/* harmony export */ });
const USER_ID = "livingmid";
const PRODUCT_IMPRESSION = "productImpression";
const PRODUCT_IMPRESSION_CLICK = "productImpressionClick";
const PRODUCT_DETAIL = "productDetail";
const ADD_TO_CART = "addToCart";
const CHECKOUT = "checkout";
const PURCHASE = "purchase";
const ARTICLE_PAGEVIEW = "living_article";
const PRODUCT_INTRO = "living_prodintro";
const ALBUM_PAGEVIEW = "photo_album";
const ALBUM_DETAIL = "photo_detail";
const BANNER_CLICK = "living_banner";
const BANNER_IMPRESSION_UNIQUE = "banner_unique_imp";
const BANNER_IMPRESSION_REPEATED = "banner_repeated_imp";
const VENDER_PAGEVIEW = "living_partner_view";
const ASSESSED_PRICE = "0";


/***/ })

}]);